import { render, staticRenderFns } from "./AlertasYCensores.vue?vue&type=template&id=72ba6dd9&"
import script from "./AlertasYCensores.vue?vue&type=script&lang=js&"
export * from "./AlertasYCensores.vue?vue&type=script&lang=js&"
import style0 from "./AlertasYCensores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports